import { gql } from '@apollo/client';

export const SEND_FEEDBACK = gql`
  mutation sendFeedback($input: FeedbackInput) {
    submitFeedback(input: $input) {
      success
    }
  }
`;
